import React, { useEffect, useState } from "react";
import AdminLayout from "../layouts/AdminLayout";
import CustomHeader from "../components/CustomHeader";
import {
  Box,
  Button,
  Checkbox,
  Divider,
  Flex,
  Heading,
  Image,
  Spinner,
  Text,
  useColorModeValue,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import CustomTabs from "../components/CustomTabs";
import PrimaryButton from "../components/PrimaryButton";
import { useNavigate } from "react-router-dom";
import visafoneIcon from "../assets/icons/visafoneIcon.svg";
import airtelIconActive from "../assets/icons/activeairtel.svg";
import visafoneIconActive from "../assets/icons/visafoneActiveIcon.svg";
import smileIcon from "../assets/icons/smileIcon.svg";
import smileIconActive from "../assets/icons/smileActiveIcon.svg";
import gloIcon from "../assets/icons/defaultglo.svg";
import airtelIcon from "../assets/icons/defaultairtel.svg";
import mtnIcon from "../assets/icons/defaultmtn.svg";
import NigeriaFlag from "../assets/icons/nigeria_flag.svg";
import nineMobileIcon from "../assets/icons/default9mobile.svg";
import gloActiveIcon from "../assets/icons/activeglo.svg";
import mtnActiveIcon from "../assets/icons/activemtn.svg";
import nineMobileActiveIcon from "../assets/icons/active9mobile.svg";
import nairaLight from "../assets/icons/light/naira.svg";
import nairaDark from "../assets/icons/dark/naira.svg";
import PhoneInputWithCountry from "../components/PhoneInput";
import RecentPurchase from "../components/RecentPurchase";
import CustomModal from "../components/CustomModal";
import AuthCardHeader from "../components/AuthCardHeader";
import { CustomDetailFlex } from "../components/CustomDeatilFlex";
import verifiedIcon from "../assets/verified.svg";
import SelectCrypto from "../components/SelectCrypto";
import SelectCryptoDropdown from "../components/SelectCryptoDropdown";
import theme from "../theme/theme";
import {
  useGetAllNetwork,
  useGetCompletedInternet,
  useGetMobileDataOfNetworkById,
  usePurchaseInternet,
} from "../utils/service.api";
import { useGetWalletWithBalance } from "../utils/wallet.api";
import failedIcon from "../assets/failedIcon.svg";
import UserInfoInput from "../components/UserInfoInput";

const Internet = () => {
  const {
    isOpen: isErrorOpen,
    onOpen: onErrorOpen,
    onClose: onErrorClose,
  } = useDisclosure();
  const navigate = useNavigate();
  const toast = useToast();
  const menuW = { base: "100%", lg: "58%" };
  const [errorMsg, setErrorMsg] = useState("");
  // const [selectedBank, setSelectedBank] = useState(1);
  const [selected, setSelected] = useState("NGN");
  const [activeTab, setActiveTab] = useState(0);
  const [operatorId, setOperatorId] = useState("");
  const [phoneNo, setPhoneNo] = useState("");
  const [amount, setAmount] = useState(0);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isSaved, setIsSaved] = useState(false);
  const [purchaseResponse, setPurchaseResponse] = useState<any>(null);
  const { data, isLoading } = useGetAllNetwork();
  const purchaseInternetMutation = usePurchaseInternet();
  const { data: productData } = useGetMobileDataOfNetworkById(operatorId);
  const { data: balanceData, isLoading: balanceLoading } =
    useGetWalletWithBalance();
  const { data: recentInternet, isLoading: recentInternetLoading } =
    useGetCompletedInternet(0, 3, operatorId);
  const menuData = [
    {
      id: 1,
      symbol: "Service Provider",
      isPlaceholder: true,
    },
    ...(productData?.map((prod: any, idx: any) => ({
      id: idx + 2,
      symbol: `${prod?.name} for ${prod?.meta?.fee} NGN`,
      productId: prod?.id,
      fee: prod?.meta?.fee,
      validity: prod?.meta?.data_expiry,
      value: prod?.meta?.data_value,
      currency: prod?.meta?.currency,
    })) || []),
  ];

  const [selectedCoin, setSelectedCoin] = useState(menuData?.[0]);
  const [isCompleteOpen, setIsCompleteOpen] = useState(false);

  const selectedTextColor = useColorModeValue("#00332D", "#EEEEEE");
  const dropIconColor = useColorModeValue("#5A5A5A", "#5A5A5A");
  const nairaIcon = useColorModeValue(nairaLight, nairaDark);
  const paraColor = useColorModeValue("#5A5A5A", "#C7C7C7");
  const paraColor2 = useColorModeValue("#5A5A5A", "#EEE");

  const onCompleteOpen = () => {
    setIsCompleteOpen(true);
    // setSelectedCoin(menuData?.[0]);
  };
  const onCompleteClose = () => {
    setPurchaseResponse(null);
    setIsCompleteOpen(false);
    setPhoneNo("");
    setIsSaved(false);
  };

  const handleTabChange = (index: number) => {
    setActiveTab(index);
    if (data && data?.data) {
      setOperatorId(data?.data?.[index]?.id);
    }
    setSelectedCoin({
      id: 1,
      symbol: "Service Provider",
      isPlaceholder: true,
    });
  };

  const getCurrentDate = () => {
    const now = new Date();
    const options: any = { day: "2-digit", month: "short", year: "numeric" };
    return now.toLocaleDateString("en-US", options);
  };

  useEffect(() => {
    setAmount(Number(selectedCoin?.fee));
  }, [data, selectedCoin]);

  useEffect(() => {
    if (data) {
      setOperatorId(data?.data?.[0]?.id);
    }
    setSelectedCoin(isLoading ? "Loading" : menuData?.[0]);
  }, [data]);

  return (
    <AdminLayout>
      <Box marginTop="72px" marginRight={"2%"} mb={"50px"} w={"95%"}>
        <CustomHeader
          para1="Internet"
          para2="Services /"
          header={"Internet"}
          amount="38,920.84"
          setSelected={setSelected}
          data={balanceData}
          isLoading={balanceLoading}
        />
        {isLoading ? (
          <Flex justify={"center"} w={"100%"} py={"20px"}>
            <Spinner />
          </Flex>
        ) : (
          <Box mt={"32px"}>
            <CustomTabs
              titles={data?.data
                // ?.filter((item: any) => item?.id !== "etisalat")
                ?.map((dat: any) => ({
                  sm: "",
                  md: dat?.name,
                  icon: (() => {
                    switch (dat?.name?.toLowerCase()) {
                      case "airtime":
                        return (
                          <Image
                            w={"28px"}
                            h={"28px"}
                            mr="5px"
                            src={airtelIcon}
                          />
                        );
                      case "9mobile":
                        return (
                          <Image
                            w={"28px"}
                            h={"28px"}
                            mr="5px"
                            src={nineMobileIcon}
                          />
                        );
                      case "glo":
                        return (
                          <Image w={"28px"} h={"28px"} mr="5px" src={gloIcon} />
                        );
                      case "mtn":
                        return (
                          <Image w={"28px"} h={"28px"} mr="5px" src={mtnIcon} />
                        );
                      case "visafone":
                        return (
                          <Image
                            w={"28px"}
                            h={"28px"}
                            mr="5px"
                            src={visafoneIcon}
                          />
                        );
                      case "smile":
                        return (
                          <Image
                            w={"28px"}
                            h={"28px"}
                            mr="5px"
                            src={smileIcon}
                          />
                        );
                      default:
                        return (
                          <Image
                            w={"28px"}
                            h={"28px"}
                            mr="5px"
                            src={airtelIcon}
                          />
                        );
                    }
                  })(),
                  activeIcon: (() => {
                    switch (dat?.name?.toLowerCase()) {
                      case "airtime":
                        return (
                          <Image
                            w={"28px"}
                            h={"28px"}
                            mr="5px"
                            src={airtelIconActive}
                          />
                        );
                      case "9mobile":
                        return (
                          <Image
                            w={"28px"}
                            h={"28px"}
                            mr="5px"
                            src={nineMobileActiveIcon}
                          />
                        );
                      case "glo":
                        return (
                          <Image
                            w={"28px"}
                            h={"28px"}
                            mr="5px"
                            src={gloActiveIcon}
                          />
                        );
                      case "mtn":
                        return (
                          <Image
                            w={"28px"}
                            h={"28px"}
                            mr="5px"
                            src={mtnActiveIcon}
                          />
                        );
                      case "visafone":
                        return (
                          <Image
                            w={"28px"}
                            h={"28px"}
                            mr="5px"
                            src={visafoneIconActive}
                          />
                        );
                      case "smile":
                        return (
                          <Image
                            w={"28px"}
                            h={"28px"}
                            mr="5px"
                            src={smileIconActive}
                          />
                        );
                      default:
                        return (
                          <Image
                            w={"28px"}
                            h={"28px"}
                            mr="5px"
                            src={airtelIconActive}
                          />
                        );
                    }
                  })(),
                }))}
              activeTab={activeTab}
              onTabChange={handleTabChange}
              showDivider={true}
            >
              {data?.data?.map((dat: any) => (
                <Flex
                  direction={{ base: "column", lg: "row" }}
                  gap="24px"
                  align={{ base: "center", lg: "start" }}
                >
                  <Box w={{ base: "100%", lg: "58%" }}>
                    <Text mt="32px" fontWeight={"700"} color={paraColor}>
                      Purchase Internet
                    </Text>
                    <Text my="24px">
                      Enter amount and the phone number to purchase a data plan.
                    </Text>
                    <SelectCrypto
                      isMenuOpen={isMenuOpen}
                      setIsMenuOpen={setIsMenuOpen}
                      selectedCoin={selectedCoin}
                      fontWeight={400}
                      iconBG="transparent"
                      dropIconColor={dropIconColor}
                      iconSize="32px"
                    />
                    {isMenuOpen && (
                      <SelectCryptoDropdown
                        {...{
                          isMenuOpen,
                          setIsMenuOpen,
                          selectedCoin,
                          setSelectedCoin,
                          menuData,
                          menuW,
                          selectedTextColor,
                        }}
                      />
                    )}
                    <Box mt="24px">
                      <UserInfoInput
                        type="tel"
                        activeIcon={NigeriaFlag}
                        placeholder="Enter Phone Number"
                        icon={NigeriaFlag}
                        name="phoneNo"
                        value={phoneNo}
                        onChange={(e: any) => {
                          const pattern = /^\d+$/;
                          if (
                            pattern?.test(e.target.value) ||
                            e.target.value === ""
                          ) {
                            setPhoneNo(e.target.value);
                          }
                        }}
                      />
                      {phoneNo && phoneNo?.length > 11 && (
                        <Text fontSize={"12"} mt="-20px" color="red">
                          Incorrect phone number.
                        </Text>
                      )}
                    </Box>

                    <Checkbox
                      colorScheme="teal"
                      onChange={(e: any) => {
                        setIsSaved(e.target.checked);
                      }}
                      isChecked={isSaved}
                    >
                      Save Address Book
                    </Checkbox>

                    <PrimaryButton
                      mt="24px"
                      text={
                        purchaseInternetMutation?.isLoading
                          ? "Processing..."
                          : "Purchase Internet"
                      }
                      disabled={
                        purchaseInternetMutation?.isLoading ||
                        amount == 0 ||
                        !amount ||
                        phoneNo?.length !== 11
                      }
                      onClick={async () => {
                        if (
                          amount == 0 ||
                          !phoneNo ||
                          !amount ||
                          phoneNo === ""
                        ) {
                          toast({
                            title: "Please enter amount and phone number",
                            status: "error",
                            duration: 3000,
                            isClosable: true,
                          });
                          return;
                        }
                        const formData = {
                          operatorId,
                          productId: selectedCoin?.productId,
                          accountId: "",
                          phoneNumber: phoneNo,
                          amount,
                          validity: selectedCoin?.validity,
                          dataPlan: selectedCoin?.value,
                          addressBook: isSaved ? "true" : "",
                        };
                        await purchaseInternetMutation
                          .mutateAsync(formData)
                          .then((result) => {
                            setPurchaseResponse(result?.dataFromApi);
                            onCompleteOpen();
                          })
                          .catch((error) => {
                            onErrorOpen();
                            setErrorMsg(error?.message);
                          });
                      }}
                    />
                  </Box>
                  {recentInternetLoading ? (
                    <Spinner />
                  ) : (
                    <RecentPurchase
                      // coin={dat?.productIds[0]?.name?.split("-")[0]}
                      empty={
                        recentInternet?.length === 0 ||
                        recentInternet === undefined
                          ? true
                          : false
                      }
                      data={recentInternet}
                      onSelect={(item: any) => {
                        const findIndex = data?.data?.findIndex(
                          (d: any) =>
                            d?.id?.toLowerCase() ===
                            item?.operatorId?.toLowerCase()
                        );
                        handleTabChange(findIndex);
                        console.log("find index", menuData);
                        const findMenuIndex = menuData?.findIndex(
                          (d: any) => d?.productId == item?.productIds
                        );
                        console.log("menu index", findMenuIndex);
                        setPhoneNo(item?.phoneNumber || "");
                        console.log(item);
                      }}
                      type="Internet"
                    />
                  )}
                </Flex>
              ))}
            </CustomTabs>
          </Box>
        )}
      </Box>
      <CustomModal
        isOpen={isCompleteOpen}
        onClose={onCompleteClose}
        headerText="Purchase Completed"
        footerText="Continue Purchasing"
        onSubmit={onCompleteClose}
      >
        <Box pt="20px" mb="-30px">
          <AuthCardHeader
            title={"Internet Purchased"}
            imgSrc={verifiedIcon}
            imageW="56px"
            des="Your purchase has been completed."
          />
        </Box>
        <Divider variant={"dashed"} />
        <CustomDetailFlex title="Date" value={getCurrentDate()} />
        <CustomDetailFlex
          title="Network"
          value={`${purchaseResponse?.network || ""}`}
        />
        <CustomDetailFlex
          title="Data Plan"
          value={purchaseResponse?.data_plan || ""}
        />
        <CustomDetailFlex title="Phone" value={purchaseResponse?.phone} />
        <CustomDetailFlex
          title="Amount"
          value={`NGN${Number(purchaseResponse?.amount || 0)?.toLocaleString(
            undefined,
            {
              maximumFractionDigits: 2,
            }
          )}`}
        />
        <CustomDetailFlex
          title="Order ID"
          value={purchaseResponse?.order_id || ""}
        />
      </CustomModal>
      <CustomModal
        isOpen={isErrorOpen}
        onClose={() => {
          onErrorClose();
          // navigate("/dashboard/index");
        }}
        noFooter={true}
        onSubmit={() => {
          // navigate("/dashboard/index");
          onErrorClose();
        }}
      >
        <Flex
          justify={"center"}
          align={"center"}
          direction={"column"}
          gap="24px"
          mb="32px"
          mt={"32px"}
        >
          <Image src={failedIcon} w={"56px"} h={"56px"} />
          <Heading
            fontFamily={"Audiowide"}
            fontSize={["15px", "18px", "21px", "24px"]}
            fontWeight={"400"}
          >
            Transaction Failed!
          </Heading>
          <Text
            textAlign={"center"}
            fontSize={["9px", "11px", "13px", "14px"]}
            fontWeight={"400"}
            lineHeight={"20px"}
            letterSpacing={"0.035px"}
            color={paraColor2}
          >
            {errorMsg}
          </Text>
        </Flex>
      </CustomModal>
    </AdminLayout>
  );
};

export default Internet;
